import { Popper } from "../../../Popper";
import { CommonData } from "../../../datastructures/gamestate/gameData";
// import * as jQuery from 'jquery';
import { ClickAwayListener } from "../../ClickAwayListener";
import { LeaderBoardUser } from "./userList";
import { playerRank } from "./userInfo";
import {  AllowedActionsTournament, allowedTournamentAction, TournamentInfosData, TournamentRanking, TournamentRegisterResponse, TournamentState } from "../Interfaces_Tournament";
import { Button } from "../../buttonsLibrary";
import { PostTournamentScreen } from "./postTournamentScreen";
// import { onOptionButtonDownRedirectHome } from "../../../functions/Functions_General";
import { TournamentRegistrationPage } from "./registrationPage";

import { convertCreditsFromServerToClient } from "../../../datastructures/Credits";
import { checkUserBalToBet } from "../../../functions/Functions_GameBar";
import { onOptionButtonDownRedirectHome } from "../../../functions/Functions_General";
import { PopupMessageBox } from "../../../messageBox";
// import { requestNewBalance } from "../../../functions/Functions_General";

// import { TournamentPlayer } from "./Interfaces_Tournament";

export class TournamentDetailsPopup extends Popper {
  private parent: PIXI.Container;
  private background: PIXI.Graphics;

  private bgBlack: PIXI.Graphics;
  private titel: PIXI.Text;
  // private userRankTitel:PIXI.Text;
  private smallTextStyle_GOLD: PIXI.TextStyle;
  private smallTextStyle_WHITE: PIXI.TextStyle;
  // private smallTextStyle_AR:PIXI.TextStyle;
  private isOpen: boolean;
  private openTween: PIXI.tween.Tween;
  private closeTween: PIXI.tween.Tween;
  private activeGameData: CommonData;
  private  isRequestingInfos:boolean=false;

  // private welcomeMessageClosed:boolean;
  private welComeMessageText: PIXI.Text;
  private welcomeMessageContainer: PIXI.Container = new PIXI.Container();
  private rankingPageContainer: PIXI.Container = new PIXI.Container();
  private resultPageContainer: PIXI.Container = new PIXI.Container();
  private registrationPageContainer: PIXI.Container = new PIXI.Container();
  private registrationPage: TournamentRegistrationPage;
  private allowedAction:string="";
  private allPagesContainers: Array<PIXI.Container> = [
    this.welcomeMessageContainer,
    this.rankingPageContainer,
    this.resultPageContainer,
    this.registrationPageContainer,
  ];
  private textParent: PIXI.Container;
  private maxRankPerPage: number;
  private tournamentInfo: PIXI.Text;
  private playerR: playerRank;
  private rankingPlayers: Array<LeaderBoardUser>;
  // private closeBtn:Button;
  private startBtn: Button;
  private startBtnlabel: PIXI.Text;

  private registerBtn: Button;
  private registerBtnlabel: PIXI.Text;

  private homeRedirectBtn:Button;
  private homeRedirectBtnLabel: PIXI.Sprite;

  private startBtnSprite: PIXI.Sprite;
  // private closeBtnSprite:PIXI.Sprite;

  private postTournament: PostTournamentScreen;
  private isTournamentEnded: boolean = false;
  // private activePageIsRanking:boolean;
  private ActiveMainPage: number;
  private pageTypeSwitchForwardBtn: Button;
  private pageSwitchSprite: PIXI.Sprite;

  private pageSwitchSprite2: PIXI.Sprite;
  private pageTypeSwitchBackwardBtn: Button;

  private rankPageNumber: number;
  private nextPageBtn: Button; //ranking all list pages
  private previousPageBtn: Button;
  // private isPortraitMode:boolean;
  private rebuyConfirmationMessage:PopupMessageBox;

  private gameExpiredMessage:PopupMessageBox;
  private serverACTIONS:allowedTournamentAction=AllowedActionsTournament;//{rebuy:"REBUY",buyIn:"BUY_IN",play: "PLAY",none:"NONE"}
  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    super(activeGameData);
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);

    this.activeGameData = activeGameData;
    this.ActiveMainPage = 0; //Welcome window 0., one for ranking and  two for result
    this.rankPageNumber = 1; //default
    this.maxRankPerPage = 10; //0;
    // this.parent.y=50;
    // this.activePageIsRanking=true;
    this.bgBlack = new PIXI.Graphics();
    this.bgBlack.beginFill(0x000000);
    // this.background.beginFill(0xff0000);
    this.bgBlack.drawRoundedRect(0, 0, 950, 950, 50);
    this.bgBlack.endFill();
    this.bgBlack.alpha = 1;
    this.bgBlack.on("pointertap", this.onClick.bind(this));
    this.parent.addChild(this.bgBlack);

    this.smallTextStyle_GOLD = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 50,
      fill: "#ff9900",
      fontWeight: "bold",
      lineHeight: 50,

      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.smallTextStyle_WHITE = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 50,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 50,

      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.background = new PIXI.Graphics();
    this.background.beginFill(0x060d10);
    // this.background.beginFill(0xff0000);
    this.background.drawRoundedRect(0, 0, 950, 950, 10);
    this.background.endFill();
    this.background.alpha = 0.95;
    this.background.on("pointertap", this.onClick.bind(this));
    this.parent.addChild(this.background);

    this.textParent = new PIXI.Container();
    this.background.addChild(this.textParent);

    //set pages as containers ;

    this.background.addChild(this.rankingPageContainer);
    this.background.addChild(this.resultPageContainer);
    this.background.addChild(this.welcomeMessageContainer);
    this.background.addChild(this.registrationPageContainer);

    //- registration page creation
    this.registrationPage = new TournamentRegistrationPage(
      this.registrationPageContainer,
      this.smallTextStyle_GOLD,
      this.activeGameData
    );
    this.registrationPage;

    //-
    this.rankingPageContainer.alpha = 0;
    this.resultPageContainer.alpha = 0;

    this.addClickAwayListener(
      new ClickAwayListener(
        activeGameData.stage,
        this.background,
        this.close.bind(this)
      )
    );

    this.titel = new PIXI.Text(
      this.activeGameData.tournamentText.TOP10,
      this.smallTextStyle_GOLD
    );
    this.titel.scale.set(0.75);
    this.titel.anchor.set(0, 0.5);
    this.textParent.addChild(this.titel);
    this.titel.x = this.background.width / 2 - this.titel.width / 2;
    this.titel.y = this.titel.height;

    this.tournamentInfo = new PIXI.Text("", this.smallTextStyle_GOLD);
    if (this.activeGameData.tournamentScoreResponse != undefined) {
      this.tournamentInfo.text =
        this.activeGameData.tournamentText.TOURNAMENT +
        " ID:" +
        this.activeGameData.tournamentScoreResponse.tournamentId;
    }
    //      this.tournamentInfo.anchor.set(0,.5);
    this.textParent.addChild(this.tournamentInfo);
    this.tournamentInfo.scale.set(0.55);
    this.tournamentInfo.x =
      this.background.width / 2 - this.tournamentInfo.width / 2;
    this.tournamentInfo.y =
      this.background.height - this.tournamentInfo.height * 5.5;

    let centerY = this.activeGameData.size[1] / 2 - this.background.height / 2;
    //----openClose tween
    this.isOpen = true;
    this.openTween = PIXI.tweenManager.createTween(this.parent);
    this.openTween.time = 500;
    this.openTween.from({ alpha: 0, y: -0 }).to({ alpha: 1, y: centerY });
    this.openTween.easing = PIXI.tween.Easing.outBack();

    this.closeTween = PIXI.tweenManager.createTween(this.parent);
    this.closeTween.time = 500;
    this.closeTween.from({ alpha: 1, y: centerY }).to({ alpha: 0, y: 0 });
    this.closeTween.easing = PIXI.tween.Easing.outExpo();

    this.postTournament = new PostTournamentScreen(
      this.resultPageContainer,
      this.smallTextStyle_WHITE,
      this.background.width,
      this.background.height,
      this.activeGameData
    );

    this.createEmptyRankList();
    //add a label for current player
    this.playerR = new playerRank(
      this.parent,
      this.smallTextStyle_WHITE,
      this.background.width,
      this.background.height,
      this.activeGameData.tournamentText
    );

    // this.closeBtnSprite=new PIXI.Sprite(PIXI.Texture.fromImage('icon_Close.png'));
    // this.closeBtn=new Button(this.closeBtnSprite,new PIXI.Rectangle(-90, -75, 180, 150));
    // // this.background.addChild(btnSprite);
    let startBtnCloseFn = this.closePopupWindow;

    this.startBtnSprite = new PIXI.Sprite(
      PIXI.Texture.fromImage("tournament_btn.png")
    );
    this.startBtn = new Button(
      this.startBtnSprite,
      new PIXI.Rectangle(-400, -50, 800, 100)
    );

    // this.background.addChild(btnSprite);
    this.startBtn.placeButton(this.background, [
      this.background.width / 2,
      this.background.height - this.startBtn.getHeight(),
    ]);
    // let startBtnCloseFn=this.closePopupWindow;
    this.startBtn.setFunction(
      function() {
        startBtnCloseFn();
      }.bind(startBtnCloseFn)
    );

    this.startBtnlabel = new PIXI.Text(
      this.activeGameData.tournamentText.CONTINUETOURNAMENT,
      this.smallTextStyle_WHITE
    );
    this.startBtnlabel.anchor.set(0.5);
    this.startBtnlabel.scale.set(0.7);
    this.startBtnSprite.addChild(this.startBtnlabel);

    //-register btn
    this.registerBtn = new Button(
      new PIXI.Sprite(PIXI.Texture.fromImage("tournament_btnRebuy.png"))
    );
    this.registerBtn.placeButton(this.background, [
      this.background.width /2+100,
      this.background.height - this.startBtn.getHeight(),
    ]);
    this.registerBtn.setFunction(     
        this.openPopupConfirmation      
    );
    this.registerBtn.setInteractive(false);
    this.registerBtnlabel = new PIXI.Text(
      "",
      this.smallTextStyle_WHITE
    );
    this.registerBtnlabel.anchor.set(0.5);
    this.registerBtnlabel.scale.set(0.7);
    this.registerBtn.getImage().addChild(this.registerBtnlabel);

      //-home btn
     
      this.homeRedirectBtn = new Button(
        new PIXI.Sprite(PIXI.Texture.fromImage("tournament_btnHome.png"))
      );
      this.homeRedirectBtn.placeButton(this.background, [
        this.background.width /2- this.registerBtn.getImage().width/2-30,
        this.background.height - this.startBtn.getHeight(),
      ]);
      // this.homeRedirectBtn.getI
      this.homeRedirectBtn.setFunction(     
          onOptionButtonDownRedirectHome      
      );
  
      this.homeRedirectBtnLabel = new PIXI.Sprite(PIXI.Texture.fromFrame('icon_Home.png'));
      this.homeRedirectBtnLabel.anchor.set(0.5);
      // this.homeRedirectBtnLabel.rotation=Math.PI;
      // this.homeRedirectBtn.getImage().rotation=Math.PI;
      // this.homeRedirectBtnLabel.scale.set();
      this.homeRedirectBtn.getImage().addChild(this.homeRedirectBtnLabel);

      
        //--


    this.creatNavigationBtns();

    this.enableBtn(false);

    let welcomeMsgStyle = new PIXI.TextStyle({
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontSize: 30,
      fill: "#ffffff",
      // fontWeight:"bold",
      lineHeight: 40,

      align: "center",
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 2,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
      wordWrap: true,
      wordWrapWidth: this.background.width - 50,
    });
    this.welComeMessageText = new PIXI.Text(
      this.activeGameData.tournamentText.WELCOMEHEAD +
        "\n\n" +
        this.activeGameData.tournamentText.WELCOMEMSG +
        "\n\n" +
        this.activeGameData.tournamentText.REWARDINFO +
        "\n\n" +
        this.activeGameData.tournamentText.WELCOMEEND,
      welcomeMsgStyle
    );
    this.welcomeMessageContainer.addChild(this.welComeMessageText);
    this.welComeMessageText.y = 100;
    // this.welComeMessageText.anchor.set(.5,0);
    this.welComeMessageText.x =
      this.background.width / 2 - this.welComeMessageText.width / 2;

    //recenter;
    this.parent.x = this.activeGameData.size[0] / 2 + 400 - 1400 / 2; //-400+this.parent.width/2;


    //redirect message pop
      this.createConfirmationMessage();
      this.createTournamenOverMessage();



    this.openConfirmation(false);
    this.close(); //close by default

    this.clearBtns();

    //testRank
    //  this.playerR.testRank();
  }
  private createConfirmationMessage=():void=>
  {
    
    this.rebuyConfirmationMessage= new PopupMessageBox(2,this.activeGameData.size,this.activeGameData);
    this.rebuyConfirmationMessage.getFrame().tint=0x00000;
    this.rebuyConfirmationMessage.setHeadText(this.activeGameData.tournamentText.REBUY);
    this.rebuyConfirmationMessage.setBodyText( "--");
    this.rebuyConfirmationMessage.setLabel(0, this.activeGameData.gameTextGeneral.NO);
    this.rebuyConfirmationMessage.setLabel(1, this.activeGameData.gameTextGeneral.YES);


    this.rebuyConfirmationMessage.setButtons(0,this.onConfirmationCancel);
    this.rebuyConfirmationMessage.setButtons(1,this.requestRegisterFunction);
      // this.rebuyConfirmationMessage.setBtns(0,["NO"],this.onConfirmationCancel)

    //
    let newbg= new PIXI.Sprite(PIXI.Texture.fromFrame('popupWindowTournament.png'))
    newbg.anchor.set(.5);
    // newbg.scale.set(1.2);
    newbg.y=this.rebuyConfirmationMessage.getFrame().height/2-30//this.messageBoxNewDesign.height;
		newbg.x=this.rebuyConfirmationMessage.getFrame().width/2//this.messageBoxNewDesign.width/2;


    this.rebuyConfirmationMessage.getFramenull().addChild(newbg);
    this.rebuyConfirmationMessage.setAlphaDefaultFrame(0);
  }
  private createTournamenOverMessage=():void=>
  {
    // gameExpiredMessage
    this.gameExpiredMessage= new PopupMessageBox(1,this.activeGameData.size,this.activeGameData);
    this.gameExpiredMessage.getFrame().tint=0x00000;
    this.gameExpiredMessage.setHeadText(this.activeGameData.tournamentText.ERROR);
      this.gameExpiredMessage.setBodyText(this.activeGameData.tournamentText.TOURNAMENTEXPIRED);
      this.gameExpiredMessage.setLabel(0, this.activeGameData.gameTextGeneral.CLOSE);


      this.gameExpiredMessage.setButtons(0,onOptionButtonDownRedirectHome);

    //
    let newbg= new PIXI.Sprite(PIXI.Texture.fromFrame('popupWindowTournament.png'));
    newbg.tint=0xff0000;
    newbg.anchor.set(.5);
    // newbg.scale.set(1.2);
    newbg.y=this.gameExpiredMessage.getFrame().height/2-30//this.messageBoxNewDesign.height;
		newbg.x=this.gameExpiredMessage.getFrame().width/2//this.messageBoxNewDesign.width/2;
    this.gameExpiredMessage.getFramenull().addChild(newbg);
    this.gameExpiredMessage.setAlphaDefaultFrame(0);


  }
  private updateRebuyMessage=(data:TournamentInfosData):void=>
  { 
    
    if( data.allowedAction==this.serverACTIONS.BUY_IN)
    {
      //is a register
      let amount:string=convertCreditsFromServerToClient(data.buyInPrice.amount).toFixed(2);
      let currency:string=data.rebuyPrice.currency;
      this.rebuyConfirmationMessage.setBodyText( this.activeGameData.tournamentText.REGISTERCONFIRMATION+" " +amount + currency+"?");
    }
    else 
    {
      //if is a rebuy
      let amount:string=convertCreditsFromServerToClient(data.rebuyPrice.amount).toFixed(2);
      let currency:string=data.rebuyPrice.currency;
      this.rebuyConfirmationMessage.setBodyText( this.activeGameData.tournamentText.REBUYCONFIRMATION+" " +amount + currency+"?");
  
    }

  }
  private onConfirmationCancel=():void=>
  { 

    this.openConfirmation(false);
    this.activeGameData.tournamentmode.openPopup();
  }

  public getMessagePopupVisible=():boolean=>
  {
    return this.rebuyConfirmationMessage.getIsOpen();
  }
  private openConfirmation=(bool:boolean):void=>
  {
      if(bool)
      {

       

          this.activeGameData.tournamentmode.closeRankingsPopup()
        
          this.closePopupWindow();

        //-
        this.rebuyConfirmationMessage.setMessageBoxVisibile(true);
        this.activeGameData.blackScreen2.setVisible(true);
      }
      else
      { 
  
        this.rebuyConfirmationMessage.setMessageBoxVisibile(false);
        this.activeGameData.blackScreen2.setVisible(false);
      }
  }
  private requestRegisterFunction=():void=>
  { 
    this.activeGameData.tournamentmode.closeRankingsPopup();
    this.openConfirmation(false);
    // console.log("REQUEST SERVER")
    this.activeGameData.API_handler.GetTournamentRegister(
      this.registerSuccess,
      this.onrequestFail
      
    );
  }

  private openPopupConfirmation=():void=>
  {
    //--check if can  do rebuy first
    if(this.allowedAction===this.serverACTIONS.REBUY ||this.allowedAction=== this.serverACTIONS.BUY_IN)
    {

      this.requestInfosForRebuyFunction();
    }

  }

  private requestInfosForRebuyFunction=():void=>
  {
    if(this.activeGameData.balance.getValue()==0 && this.activeGameData.betResponse.gameContext.contextData.finished)
    {   
        this.activeGameData.API_handler.GetTournamentInfos(
        this.checkRebuyStillAvailable,
        this.displayTournamentNotActiveMessage      
      );
    }
  }

  private checkRebuyStillAvailable=(data: TournamentInfosData):void=>
  {
      //-check the tournament state
      let isTournamentExpired=data.tournamentState;
      if(isTournamentExpired===TournamentState.ACTIVE )
      {   
        this.allowedAction=data.allowedAction;
        if(this.allowedAction === this.serverACTIONS.BUY_IN || this.allowedAction === this.serverACTIONS.REBUY)
        {
          this.openConfirmation(true);
        }
          
      }
      else
      { 
        this.displayTournamentNotActiveMessage();
      }
    
  }
 
        
  
  private requestInfosFunction=():void=>
  {


    ///-
    if(this.activeGameData.balance.getValue()==0 && this.activeGameData.betResponse.gameContext.contextData.finished)
    {

      this.allowRegister(false);
    }

    //
    this.activeGameData.API_handler.GetTournamentInfos(
      this.infosSuccess,
      this.onrequestFail
      
    );

    //
  }

  private updateTournamentDetails = (): void => {
    if(this.activeGameData.balance.getValue()==0 && this.activeGameData.betResponse.gameContext.contextData.finished)
    {
      this.isTournamentEnded=true;
      this.isTournamentEnded;
      // this.displayGrayRegisterBtn(this.isTournamentEnded);
   
    }
    else
    {
      this.isTournamentEnded=false;
      // this.displayGrayRegisterBtn(this.isTournamentEnded);
    
    }


    
 
  };


  private updateInformation=():void=>
  {
    if(this.isRequestingInfos===false )
    { 

      this.isRequestingInfos=true;
      this.requestInfosFunction();
    }
  }

  private infosSuccess=(data: TournamentInfosData):void=>
  {
      //-check the tournament state
      // console.log(data,data.tournamentState,TournamentState.ACTIVE)
      let isTournamentExpired=data.tournamentState;
      if(isTournamentExpired===TournamentState.ACTIVE )
      {
        //can still play
        this.updateGameInfosPages(data);
      }
      else
      { 
        this.displayTournamentNotActiveMessage();
      }
  }
  private displayTournamentNotActiveMessage=():void=>
  { 
    //-lock game 
    this.allowedAction=this.serverACTIONS.NONE; 
    this.allowRegister(false);

    ///----


    //--
    console.error("TOURNAMENT NOT ACTIVE ANYMORE");
    // stop the ticker
    this.activeGameData.tournamentmode.enableAutoUpdate(false);
    this.activeGameData.blackScreen2.setVisible(true);
    this.gameExpiredMessage.setMessageBoxVisibile(true);
    this.closePopupWindow();

    this.activeGameData.disableAllBtns(this.activeGameData);
  }
  private updateGameInfosPages = (data: TournamentInfosData): void => {

      // console.log("REQUEST INFO SUCCESS", data);
    
    //-update the rebuy
    this.registrationPage.updateRegistrationFee(convertCreditsFromServerToClient(data.buyInPrice.amount).toFixed(2) +data.buyInPrice.currency );
    this.registrationPage.updateRebuyLeft(data.numberOfRebuysLeft+"/"+data.maxNumberOfRebuys );
    this.registrationPage.updateRebuyFee(convertCreditsFromServerToClient(data.rebuyPrice.amount).toFixed(2)+data.rebuyPrice.currency );




    // let actionsPossible:allowedTournamentAction=  AllowedActionsTournament;
   
    // console.log(data, data.allowedAction,actionsPossible.REBUY)
    this.allowedAction=data.allowedAction.toString().toUpperCase(); 
   if(this.allowedAction==this.serverACTIONS.REBUY)
   {
    console.log("SHOW REBUY")
    this.registerBtnlabel.text = this.activeGameData.tournamentText.REBUY + " ("+convertCreditsFromServerToClient(data.rebuyPrice.amount).toFixed(2)+data.rebuyPrice.currency+ ")" ;
    this.allowRegister(true);
   } 
   else  if(this.allowedAction==this.serverACTIONS.BUY_IN)
   {
    console.log("SHOW REGISTER")
    this.registerBtnlabel.text = this.activeGameData.tournamentText.REGISTER + " ("+convertCreditsFromServerToClient(data.buyInPrice.amount).toFixed(2)+data.buyInPrice.currency+ ")" ;
    this.allowRegister(true);
    //show the exit page but disable the  rebuy btn
   }
   else   if(this.allowedAction==this.serverACTIONS.PLAY)
  { 
    console.log("SHOW CONTINUE")
     //show the exit page but disable the  rebuy btn;
    //  this.displayGrayRegisterBtn(false);
    this.displayContinueBtn();
  }

  else   if(this.allowedAction==this.serverACTIONS.NONE)
  { 
    console.log("SHOW CLOSE")
     //show the exit page but disable the  rebuy btn;
     this.allowRegister(false);

   
  }
  else
  {
    console.log("CONDITION NOT MET",)
    this.allowRegister(false);
  }  
  



    // update ranking

    this.activeGameData.tournamentmode.requestInfoSuccesRankUpdate();//request for rankinf
    
    this.isRequestingInfos=false;
    //

    this.updateRebuyMessage(data);
  };
  public getIsTournamentEnded=():boolean=>
  {
    return this.isTournamentEnded=true;
  }
  private allowRegister=(bool:boolean):void=>
  { 
    this.startBtn.setScale(0);
    if(bool)
    {
      // console.log("enabled btn")
      this.registerBtn.setScale(1);
      //reset interactivity
      this.registerBtn.setInteractive(true);
      this.registerBtn.getImage().tint=0xffffff;
      this.homeRedirectBtn.setScale(1);
    }
    else
    {
      // console.log("disabled btn")
      this.registerBtn.setScale(1);
      //reset interactivity
      this.registerBtn.setInteractive(false);
      this.registerBtn.getImage().tint=0x333333;
      this.homeRedirectBtn.setScale(1);
    }
  }


  private clearBtns=():void=>
  {
    this.registerBtn.setScale(0);
    this.homeRedirectBtn.setScale(0);
    this.startBtn.setScale(0);
  }
  private displayContinueBtn=():void=>
  {
    this.registerBtn.setScale(0);
    this.homeRedirectBtn.setScale(0);
    this.startBtn.setScale(1);
  }
  // private displayGrayRegisterBtn = (bool: boolean): void => {

  //   this.registerBtn.setScale(0);
  //   this.homeRedirectBtn.setScale(0);
  //   this.startBtn.setScale(0);    
  //   //
  //   if (bool) {
  //     // console.log("show disabled btn")
  //     this.allowRegister(false);//btn visible bur not clickable
    
  //   } else {
  //     // console.log("show continue btn")
  //     this.startBtn.setScale(1);
  //   }
  // };

  private creatNavigationBtns = (): void => {
    //btn toggle result and list pasge
    this.pageSwitchSprite = new PIXI.Sprite(
      PIXI.Texture.fromImage("tournament_nextPage.png")
    );
    this.pageSwitchSprite.scale.set(0.7);
    this.pageTypeSwitchForwardBtn = new Button(
      this.pageSwitchSprite,
      new PIXI.Rectangle(-70, -70, 140, 140)
    );

    // this.background.addChild(btnSprite);
    this.pageTypeSwitchForwardBtn.placeButton(this.background, [50, 50]);
    // let startBtnCloseFn=this.closePopupWindow;
    let changePageType = this.changePageType;
    this.pageTypeSwitchForwardBtn.setFunction(
      function() {
        changePageType(true);
      }.bind(changePageType)
    );

    this.pageSwitchSprite2 = new PIXI.Sprite(
      PIXI.Texture.fromImage("tournament_nextPage.png")
    );
    this.pageSwitchSprite2.scale.set(0.7);
    this.pageTypeSwitchBackwardBtn = new Button(
      this.pageSwitchSprite2,
      new PIXI.Rectangle(-70, -70, 140, 140)
    );

    // this.background.addChild(btnSprite);
    this.pageTypeSwitchBackwardBtn.placeButton(this.background, [50, 50]);
    this.pageTypeSwitchBackwardBtn.setFunction(
      function() {
        changePageType(false);
      }.bind(changePageType)
    );

    // this.setBtnPageSwitchLocation();

    this.pageSwitchSprite.rotation = Math.PI / 2;
    this.pageTypeSwitchForwardBtn.setPosition([this.background.width - 50, 50]);
    this.pageSwitchSprite2.rotation = -Math.PI / 2;
    this.pageTypeSwitchBackwardBtn.setPosition([50, 50]);
    //------------------

    //btn next and previous ranking page
    let spriteNEXT = new PIXI.Sprite(
      PIXI.Texture.fromImage("tournament_up.png")
    );
    spriteNEXT.rotation = Math.PI;
    spriteNEXT.scale.set(0.7);
    this.nextPageBtn = new Button(
      spriteNEXT,
      new PIXI.Rectangle(-70, -70, 140, 140)
    );
    this.nextPageBtn.placeButton(this.rankingPageContainer, [
      this.background.width - 50,
      this.background.height / 2 + 35,
    ]);
    let addSubstractPageN = this.addSubtractPageNumber;
    this.nextPageBtn.setFunction(
      function() {
        addSubstractPageN(1);
      }.bind(addSubstractPageN)
    );

    let spritePrevious = new PIXI.Sprite(
      PIXI.Texture.fromImage("tournament_up.png")
    );
    spritePrevious.scale.set(0.7);
    this.previousPageBtn = new Button(
      spritePrevious,
      new PIXI.Rectangle(-70, -70, 140, 140)
    );
    this.previousPageBtn.placeButton(this.rankingPageContainer, [
      this.background.width - 50,
      this.background.height / 2 - 150,
    ]);
    this.previousPageBtn.setFunction(
      function() {
        addSubstractPageN(0);
      }.bind(addSubstractPageN)
    );

    if (this.activeGameData.isMobile == false) {
      this.pageSwitchSprite.scale.set(0.5);
      this.pageSwitchSprite2.scale.set(0.5);
      spritePrevious.scale.set(0.5);
      spriteNEXT.scale.set(0.5);
    }
  };

  private addSubtractPageNumber = (btnIndex: number): void => {
    let changePage = false;

    if (btnIndex == 0) {
      //substract
      if (this.rankPageNumber - 1 > 0) {
        this.rankPageNumber--;
        changePage = true;
      }
    }

    if (btnIndex == 1) {
      // if(this.activeGameData.tournamentResponse!=undefined && this.activeGameData.tournamentResponse.numberOfPages!=undefined)
      if (
        this.rankPageNumber + 1 <=
        this.activeGameData.tournamentResponse.numberOfPages
      ) {
        this.rankPageNumber++;
        changePage = true;
      }
    }
    if (changePage) {
      // console.log(this.rankPageNumber,btnIndex)
      this.requestNewPage();
    }
  };

  // private if
  private requestNewPage = (): void => {
    let pageData = {
      page: this.rankPageNumber,
      limit: this.maxRankPerPage,
    };
    this.activeGameData.API_handler.GetTournamentRanking(
      pageData,
      this.serverRequestNewPageSuccess.bind(self),
      this.serverRequestFail.bind(self)
    );

    // let list=[ {"position":1,"displayName":"Dd","score":1000,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":2,"displayName":"Diia","score":500,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":3,"displayName":"Dish","score":200,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":4,"displayName":"Desh","score":100,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":5,"displayName":"Diiph","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":6,"displayName":"Diiph","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":7,"displayName":"Diipe","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":8,"displayName":"Dish","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":9,"displayName":"ipesh","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":10,"displayName":"Desh","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":11,"displayName":"Dii","score":110,"prize":{"amount":5000,"currency":"EUR"}},
    // {"position":12,"displayName":"Desh","score":110,"prize":{"amount":5000,"currency":"EUR"}},];

    // let fakeData=
    // {"playerCurrentEntry":{"position":1,"displayName":"Diipesh","score":0,"prize":{"amount":5000,"currency":"EUR"}},
    // "playerTopEntry":{"position":1,"displayName":"Diipesh","score":0,"prize":{"amount":5000,"currency":"EUR"}},
    // "totalNumberOfEntries":12,
    // "entries":[list[this.rankPageNumber-1]

    // ],"page":this.rankPageNumber,"numberOfPages":12}

    // this.serverRequestSuccess(fakeData);
    // this.serverRequestFail
  };

  public getMaxRankPerPage = (): number => {
    return this.maxRankPerPage;
  };
  public getCurrentPage = (): number => {
    return this.rankPageNumber;
  };

  private serverRequestNewPageSuccess = (data: TournamentRanking): void => {
    this.setRankingFromData(data);
    if (this.activeGameData != undefined) {
      this.activeGameData.tournamentResponse = data;
    }

    if (
      this.tournamentInfo.text == "" &&
      this.activeGameData.tournamentScoreResponse != undefined
    ) {
      this.setTournamentID(
        this.activeGameData.tournamentScoreResponse.tournamentId
      );
    }
  };

  public setTournamentID = (newId: number): void => {
    if (this.tournamentInfo.text == "") {
      this.tournamentInfo.text =
        this.activeGameData.tournamentText.TOURNAMENT + " ID:" + newId;
    }
  };
  private serverRequestFail = (): void => {
    //disable game and show error msg
    console.log("CANNOT PROCEED");
  };

  private changePageType = (goForWard: boolean): void => {
    if (goForWard && this.ActiveMainPage < this.allPagesContainers.length - 1) {
      this.ActiveMainPage++;
    } else if (
      goForWard &&
      this.ActiveMainPage == this.allPagesContainers.length - 1
    ) {
      this.ActiveMainPage = 0;
    } else if (goForWard == false && this.ActiveMainPage > 0) {
      this.ActiveMainPage--;
    } else {
      this.ActiveMainPage = this.allPagesContainers.length - 1;
    }

    // console.log(this.ActiveMainPage);
    this.changeMainPage();

    // this.setEndScreen(this.isTournamentEnded);
  };
  private enableBtn = (bool: boolean): void => {
    this.startBtn.setInteractive(bool);
    // console.log("CHECK IF GAME ACTIVE")
    if(this.allowedAction===this.serverACTIONS.BUY_IN || this.allowedAction===this.serverACTIONS.REBUY)
    {
      // console.log("GAME IS ACTIVE")
      this.registerBtn.setInteractive(bool);
    }
    else
    {this.registerBtn.setInteractive(false);
      // console.log("GAME IS NOT ACTIVE")
    }
    
    // this.closeBtn.setInteractive(bool);
    this.pageTypeSwitchForwardBtn.setInteractive(bool);

    this.pageTypeSwitchBackwardBtn.setInteractive(bool);

    // if(bool==false)
    // {
    //     this.setTournamentPageBtnActive(bool)
    // }

    // if(bool)
    // {
    //     if(this.ActiveMainPage==1)//is ranking
    //     {
    //         this.setTournamentPageBtnActive(true)
    //     }
    // }
    // else
    // {
    //     this.setTournamentPageBtnActive(false)
    // }
  };

  private setTournamentPageBtnActive(bool: boolean) {
    this.nextPageBtn.setInteractive(bool);
    this.previousPageBtn.setInteractive(bool);
    let newAlpha = bool ? 1 : 0;
    this.nextPageBtn.setAlpha(newAlpha);
    this.previousPageBtn.setAlpha(newAlpha);

    // console.log('CLICKABLE',bool)
  }

  private changeMainPage = (): void => {
    this.goToPage(this.ActiveMainPage);
    // console.log('goToPage',this.ActiveMainPage)
  };

  private goToPage = (pageNum: number): void => {
    this.setTournamentPageBtnActive(false); //default
    this.hideAllPages();
    if (pageNum == 0) {
      this.titel.text = this.activeGameData.tournamentText.TOURNAMENT;
      this.titel.x = this.background.width / 2 - this.titel.width / 2;
      this.welcomeMessageContainer.alpha = 1;
      // this.rankingPageContainer.alpha=0;
      // this.resultPageContainer.alpha=0;
      this.playerR.setRebuyMode(false);
      // console.log('WELCOME PAGE')
    } else if (pageNum == 1) {
      this.titel.text = this.activeGameData.tournamentText.TOP10;
      this.titel.x = this.background.width / 2 - this.titel.width / 2;
      // this.postTournament.setVisbile(false);            //

      this.setTournamentPageBtnActive(true); //enable the btn to chnage ranking pages
      this.rankingPageContainer.alpha = 1;
      // this.resultPageContainer.alpha=0;
      // this.welcomeMessageContainer.alpha=0;
      this.playerR.setRebuyMode(false);
      // console.log('RANK PAGE')
    } else if (pageNum == 2) {
      this.titel.text = this.activeGameData.tournamentText.TOURNAMENTRESULTS;
      this.titel.x = this.background.width / 2 - this.titel.width / 2;
      // this.postTournament.setVisbile(true);
      // this.rankingPageContainer.alpha=0;
      // this.welcomeMessageContainer.alpha=0;
      this.resultPageContainer.alpha = 1;
      this.playerR.setRebuyMode(true);
      // console.log('RESULT PAGE');
    } else if (pageNum == 3) {
      //registration page
      this.registrationPageContainer.alpha = 1;
      this.titel.text = this.activeGameData.tournamentText.REGISTER;
      this.titel.x = this.background.width / 2 - this.titel.width / 2;
      this.playerR.setRebuyMode(false);
    }

    this.updateTournamentDetails();
  };

  public hideAllPages = (): void => {
    for (let i = 0; i < this.allPagesContainers.length; i++) {
      this.allPagesContainers[i].alpha = 0;
    }
  };
  // private  (tournamentPageIndex:number)
  // {

  //          // request given page and load

  // }

  private closePopupWindow = (): void => {
    this.close();
    this.setInteractivity();
    // this.startBtn.setAlpha(0);
    // this.startBtn.setInteractive(false);
  };
  private createEmptyRankList = (): void => {
    // exampledata
    // let junkDatas={"entries":[{"position":1,"displayName":"wardb","score":1800,"prize":{"amount":5000,"currency":"EUR"}},{"position":2,"displayName":"Diipesh","score":0,"prize":{"amount":5000,"currency":"EUR"}}]}

    this.rankingPlayers = [];

    for (let i = 0; i < this.maxRankPerPage; i++) {
      // if(i<3)
      // {
      //     this.rankingPlayers[i]=new LeaderBoardUser(this.rankingPageContainer,this.background.width,this.smallTextStyle_GOLD,i+1);

      // }
      // else
      // {
      this.rankingPlayers[i] = new LeaderBoardUser(
        this.rankingPageContainer,
        this.background.width,
        this.smallTextStyle_WHITE,
        i + 1
      );

      if (i > 0) {
        this.rankingPlayers[i].setPosY(
          this.rankingPlayers[i - 1].getPosY() +
            this.rankingPlayers[i - 1].getHeight() * 1.1
        );
      } else {
        this.rankingPlayers[i].setPosY(
          this.rankingPlayers[i].getHeight() * i + 1 + 100
        );
      }
    }

    // this.goToPage(this.ActiveMainPage);
  };

  public setNewScore = (score: number) => {
    this.playerR.setScore(score);
  };
  // public setRankOnlyAfterRebuy=(newPosition:number,totalEntries:number):void=>
  // {
  //   this.playerR.setRankOnly(newPosition,totalEntries);
  // }
  public setRankingFromData = (data: TournamentRanking): void => {
    let maxServerData = data.entries.length;
    // update the top 10 ranking list
    for (let i = 0; i < this.maxRankPerPage; i++) {
      if (i < maxServerData) {
        this.rankingPlayers[i].setData(data.entries[i]);
      } else {
        this.rankingPlayers[i].setEmpty();
      }
    }

    //update the userData;
    let playerData = data.playerCurrentEntry;
    this.playerR.setPlayerData(playerData, data.totalNumberOfEntries); //allexceptscore

    //update the post screen
    this.postTournament.setPostSceenData(data);

    //update rebuyLeft

    // this.updateTournamentDetails();
  };

  // private setScore=():void=>
  // {
  //     this.playerR.setPlayerData(playerData,data.totalNumberOfEntries);

  //     //update the post screen
  //     this.postTournament.setPostSceenData(data);
  // }

  private setInteractivity = (): void => {
    // console.log('Change game interactivity',this.isOpen)
    if (this.isOpen) {
      this.activeGameData.disableAllBtns(this.activeGameData);
      this.enableBtn(true);
      // this.activeGameData.tournamentmode.enableAutoUpdate(true);
    } else {
      let selectedActionBeforeReset=this.activeGameData.serverAction;
      this.activeGameData.resetAllBtns(this.activeGameData);
      if(this.activeGameData?.betResponse?.gameContext?.contextData?.allowedInputActions.indexOf(selectedActionBeforeReset)>=0)
      {
        this.activeGameData.serverAction=selectedActionBeforeReset;//write it back in order to fix the buybonus
      }
      this.enableBtn(false);
    }
  };
  public openPopUpWindow = (pageNum: number): void => {
    this.ActiveMainPage = pageNum;
    this.updateTournamentDetails();
    this.changeMainPage();
    if (this.isOpen == false) {
      this.onClick();
    }
    this.updateInformation();//update the user infos
  };
  public onClick() {
    // console.log("counts")

    if (this.isOpen) {
      //close
      this.isOpen = false;
      this.close();
      this.setInteractivity();
      //--

      //-open
      // this.activeGameData.blackScreen2.setVisible(true);
      // console.log('CLOSE')
    } else {
      this.closeTween.stop();
      this.closeTween.reset();
      this.openTween.reset();
      this.openTween.start();
      this.isOpen = true;
      this.open();
      this.setInteractivity();

      // --
      this.activeGameData.blackScreen2.setVisible(true);
      // console.log('OPEN')
    }
  }

  public removeFromCanvas() {
    // this.makeClickable(false);
    if (this.isOpen) {
      this.openTween.stop();
      this.openTween.reset();
      this.closeTween.reset();
      this.closeTween.start();
      // this.activeGameData.jackpotBarClose.buttonMode = false;
      // this.activeGameData.jackpotBarClose.interactive = false;
      this.isOpen = false;
      //---
      // this.setInteractivity();
      this.activeGameData.blackScreen2.setVisible(false);
    }
    if (this.activeGameData.resetAllBtns != undefined) {
      this.setInteractivity();
    }
  }

  public setVisible = (bool: boolean): void => {
    this.parent.alpha = bool ? 1 : 0;
    // this.closeBtn.setInteractive(bool);
    // this.noWinnerText.alpha=(!bool? 1 : 0)
  };
  public getVisible = (): boolean => {
    let bool = this.parent.alpha ? true : false;
    return bool;
  };

  public setPortraitMode = (): void => {
    // this.isPortraitMode=true;
    let mobileScale = 2;
    this.parent.scale.set(mobileScale);
    this.parent.x =
      this.activeGameData.size[0] / 2 -
      (this.background.width / 2) * mobileScale;
    this.background.y = 400;
    //    console.log(this.parent.x)
    this.playerR.setPortraitMode();
    this.changeMainPage();
  };

  public setLandscapeMode = (): void => {
    // this.isPortraitMode=false;
    this.parent.scale.set(1);
    this.background.y = 0;

    this.parent.y =
      this.activeGameData.size[1] / 2 - this.background.height / 2;
    this.parent.x = 685; //this.activeGameData.size[0]/2-this.parent.width/2+400///2+400-1400/2//-400+this.parent.width/2;
    this.playerR.setLandscapeMode();

    this.changeMainPage();
    // console.log(parent.x)
  };

  public setEndScreen = (bool: boolean): void => {

    
    this.isTournamentEnded = bool;

    if (bool) {
      this.updateTournamentDetails();
      this.updateInformation();//update the user infos
      this.ActiveMainPage = 2;
      // this.changeCloseToUrl();
    }

    this.changeMainPage();
  };

  // private changeCloseToUrl = (): void => {
  //   // this.activeGameData.API_handler.GetTournamentRegister(this.registerSuccess,this.activeGameData.betFail)
  //   let fn = this.activeGameData.API_handler.GetTournamentRegister.bind(
  //     this.registerSuccess,
  //     this.activeGameData.betFail
  //   );
  //   this.startBtn.setFunction(fn);
  // };
  private registerSuccess = (data: TournamentRegisterResponse): void => {
  
    console.log("Success TournamentRegisterResponse, starting new session of the game", data);


    //--clear and reset  current game t
    if(this.activeGameData.mainGame!=undefined && this.activeGameData.mainGame.resetGameForTournament!=undefined)
    {
      this.activeGameData.mainGame.resetGameForTournament();
    }
   
    //
    //-randomize game 
    if(this.registerBtnlabel.text.includes(this.activeGameData.tournamentText.REBUY))
    {
      //-if BTN IS REBUY
      //clear current game?
    } 
    this.isTournamentEnded = false;
  
  
    //--update balance
    // requestNewBalance(this.activeGameData);
  
  
  //set new balance from the loading
    let value = data.tournamentParticipationBalance.amount;
    this.activeGameData.betResponse.playerBalance.creditsBalance.amount=value;
    this.activeGameData.balance.updateValue(value);
    this.activeGameData.gameBar.setBalValue(this.activeGameData.balance.getDisplayValue());
    // console.log('REQUEST SUCCESS')
    checkUserBalToBet(this.activeGameData);
    this.closePopupWindow();    
    //request ranking
    this.requestNewPage();
    //updatetournament details
    this.updateTournamentDetails(); //convert the register/rebuy  btn to  continue

    this.updateInformation();//update the user infos

    //--for roulette update it  seprately
    if(this.activeGameData.isTableGame)
    {
      this.activeGameData.betResponse.playerBalance.creditsBalance.amount=value;
      console.log(this.activeGameData.betResponse.playerBalance.creditsBalance.amount)
      console.log(this.activeGameData.mainGame)
      this.activeGameData.mainGame.updateBalance();
    }


    if(this.activeGameData.BuyBonus!=undefined)
    {
      //check if buy bonus conditions are met
      this.activeGameData.BuyBonus.enableBuyBonusIfAllowed(true);
    }
  };
  private onrequestFail=():void=>
  {
    this.activeGameData.betFail();
  
  }

  public onResize = (): void => {
    let canvas = document.getElementsByTagName("canvas")[0];
    let multiplierScale =
      this.activeGameData.gameResolution[1] / this.activeGameData.size[1];

    this.bgBlack.height;

    this.bgBlack.height =
      canvas.height / multiplierScale - 600 / multiplierScale;
    this.bgBlack.y = 0; //-this.activeGameData.portraitPlayOffsetTop*multiplierScale//-50)*multiplierScale;
  };
  public setDefaultSize = (): void => {
    if (this.bgBlack.height != 0) {
      this.bgBlack.height = 0;
      this.bgBlack.y = 0;
    }
  };
}
